// Math[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-math-@@tostringtag
require('../internals/set-to-string-tag')(Math, 'Math', true);



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.math.to-string-tag.js
// module id = 590
// module chunks = 0